/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Elastic_Gallery_View_ProjectInputs */

const en_elastic_gallery_view_project = /** @type {(inputs: Elastic_Gallery_View_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View project`)
};

const ar_elastic_gallery_view_project = /** @type {(inputs: Elastic_Gallery_View_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عرض المشروع`)
};

const bn_elastic_gallery_view_project = /** @type {(inputs: Elastic_Gallery_View_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রজেক্ট দেখুন`)
};

const de_elastic_gallery_view_project = /** @type {(inputs: Elastic_Gallery_View_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projekt ansehen`)
};

const es_elastic_gallery_view_project = /** @type {(inputs: Elastic_Gallery_View_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver proyecto`)
};

const fr_elastic_gallery_view_project = /** @type {(inputs: Elastic_Gallery_View_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir le projet`)
};

const pt_elastic_gallery_view_project = /** @type {(inputs: Elastic_Gallery_View_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver projeto`)
};

const zh_elastic_gallery_view_project = /** @type {(inputs: Elastic_Gallery_View_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看项目`)
};

const tr_elastic_gallery_view_project = /** @type {(inputs: Elastic_Gallery_View_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projeyi görüntüle`)
};

const ru_elastic_gallery_view_project = /** @type {(inputs: Elastic_Gallery_View_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Посмотреть проект`)
};

const pl_elastic_gallery_view_project = /** @type {(inputs: Elastic_Gallery_View_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zobacz projekt`)
};

/**
* | output |
* | --- |
* | "View project" |
*
* @param {Elastic_Gallery_View_ProjectInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const elastic_gallery_view_project = /** @type {((inputs?: Elastic_Gallery_View_ProjectInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Elastic_Gallery_View_ProjectInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_elastic_gallery_view_project(inputs)
	if (locale === "bn") return bn_elastic_gallery_view_project(inputs)
	if (locale === "de") return de_elastic_gallery_view_project(inputs)
	if (locale === "es") return es_elastic_gallery_view_project(inputs)
	if (locale === "fr") return fr_elastic_gallery_view_project(inputs)
	if (locale === "pt") return pt_elastic_gallery_view_project(inputs)
	if (locale === "zh") return zh_elastic_gallery_view_project(inputs)
	if (locale === "tr") return tr_elastic_gallery_view_project(inputs)
	if (locale === "ru") return ru_elastic_gallery_view_project(inputs)
	if (locale === "pl") return pl_elastic_gallery_view_project(inputs)
	return en_elastic_gallery_view_project(inputs)
});